import { setMapRef } from 'app/actions/map';
import { MapFilterWindow, MapLeaflet, MapTaskWindow, MapTransportWindow } from 'app/pages/Map';
import { transportHistoryTracksItemsStop } from 'app/store/map';
import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
const Map = () => {
    const mapRef = useRef(null);
    const dispatch = useDispatch();
    const isTaskWindowVisible = useSelector((state) => !!state.map.taskSelectedItem);
    const isTransportWindowVisible = useSelector((state) => !!state.map.transportSelectedItem);
    useEffect(() => {
        dispatch(setMapRef(mapRef));
        return () => {
            dispatch(transportHistoryTracksItemsStop());
            dispatch(setMapRef({ current: null }));
        };
    }, [mapRef, dispatch]);
    return (React.createElement(React.Fragment, null,
        React.createElement(MapFilterWindow, null),
        React.createElement(MapLeaflet, { ref: mapRef }),
        isTaskWindowVisible && React.createElement(MapTaskWindow, null),
        isTransportWindowVisible && React.createElement(MapTransportWindow, null)));
};
export default Map;
